<template>
    <Head :title="page_name"/>

    <BreezeShopLayout>
        <template #header>
            <!-- <h2 class="
              font-semibold
              text-lg
              md:text-lg md:text-xl
              text-gray-800
              leading-tight
            ">
              {{
                page_name +
                " (" +
                this.data.meta.total +
                " Event" +
                (this.data.meta.total === 1 ? ")" : "s)")
              }}
            </h2> -->
            <h2 class="text-gray-800 leading-tight">
                <div class="font-bold text-xl">{{ page_name }}</div>
                <div class="text-sm">{{
                        this.data.meta.total +
                        " Upcoming Event" +
                        (this.data.meta.total === 1 ? "" : "s")
                    }}
                </div>
            </h2>
        </template>

        <div class="pb-6 md:pb-10">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div v-if="flash.message" class="bg-green-500 rounded text-white px-4 py-3 shadow-md my-3" role="alert">
                    <div class="flex">
                        <div>
                            <p class="text-sm">{{ flash.message }}</p>
                        </div>
                    </div>
                </div>
                <!-- <div
                  class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4 py-3 md:py-4 px-3 md:px-0">
                  <SelectInput :options="city_filter.options" :value="city_filter.selected" placeholder="Filter by city"
                    @update="updateFilter($event, 'city')" />
                  <SelectInput :options="month_filter.options" :value="month_filter.selected" placeholder="Filter by date"
                    @update="updateFilter($event, 'month')" />
                </div> -->
                <div class="mt-3">
                    <Tabs :active="activeTab" :tabs="['EVENTS', 'INFO']" @update="activeTab = $event">

                        <div v-if="activeTab === 'EVENTS'">

                            <div class="md:hidden pb-3" @click="filtersOpen = true">
                                <div
                                    class="bg-blue-500 rounded text-white px-2 sm:px-3 py-1 text-xs font-medium cursor-pointer transition hover:bg-blue-600">
                                    {{
                                        activeFilterCount ? activeFilterCount + " Filter" + (activeFilterCount > 1 ? 's' :
                                            '') + " Applied" :
                                            "Filter City or Date"
                                    }}
                                </div>
                            </div>

                            <div class="hidden md:flex gap-2 text-slate-800 pb-3">
                                <!-- TODO: Update the selects to not allow text (annoying on phones) -->
                                <SelectInput :options="city_filter.options" :value="city_filter.selected"
                                             class="min-w-[200px]"
                                             placeholder="Filter by city" @update="updateFilter($event, 'city')"/>
                                <SelectInput :options="month_filter.options" :value="month_filter.selected"
                                             class="min-w-[200px]"
                                             placeholder="Filter by date" @update="updateFilter($event, 'month')"/>
                            </div>

                        </div>

                    </Tabs>
                </div>
                <div :class="{ hidden: activeTab !== 'EVENTS' }">
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">

                        <div v-if="!data.data.length">
                            <h2 class="
              font-semibold
              text-lg
              md:text-xl
              text-gray-800
              leading-tight
              p-8
            ">
                                No upcoming shows
                            </h2>
                        </div>
                        <div v-else>
                            <div class="hidden md:block">
                                <div class="border-b-1 flex w-full font-semibold text-lg text-blue-600">
                                    <div class="px-4 py-2 w-4/12">Event</div>
                                    <div class="px-4 py-2 w-3/12">Venue</div>
                                    <div class="px-4 py-2 w-3/12">Dates</div>
                                    <div class="px-4 py-2 w-2/12"></div>
                                </div>
                            </div>
                            <!-- <div class="bg-white shadow-sm sm:rounded-lg">

                                <div :class="{ hidden: activeTab !== 'tickets' }" class="p-4 pt-8" -->
                            <div v-for="row in data.data" :key="row.id" class="
              border-t
              flex
              items-center
              w-full
              cursor-pointer
              md:hover:bg-gray-200
              transition-colors
            " @click="$inertia.visit(row.link)">

                                <div class="md:hidden w-3/12 md:w-2/12 pl-4 py-6 pr-0 flex items-center justify-center">
                                    <img :src="row.production.image_src" class="shadow-md rounded max-h-32"/>
                                </div>

                                <div class="px-4 py-3 w-8/12 md:w-4/12 md:flex md:justify-start md:items-center gap-4">
                                    <div class="h-14 w-14 hidden md:flex md:justify-center md:items-center">
                                        <img :src="row.production.image_src"
                                             class="shadow-md rounded max-h-full max-w-full"/>
                                    </div>
                                    <div>
                                        <div class="md:font-semibold sm:text-lg">
                                            {{ row.production.name }}
                                        </div>
                                        <div class="hidden md:block">
                                            {{ $page.props.currentCompany.name }}
                                        </div>
                                        <div class="md:hidden text-sm sm:text-base">
                                            <div class="font-semibold text-base">
                                                {{ row.venue.name }}
                                                <!-- (Doors {{ row.doors_time }}) -->
                                            </div>
                                            <div class="text-slate-500">{{ row.event_dates }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="px-4 py-3 w-3/12 hidden md:block">
                                    <div class="font-semibold text-lg">{{ row.venue.city }}</div>
                                    {{ row.venue.name }}
                                </div>
                                <div class="px-4 py-3 w-3/12 hidden md:block">
                                    <div class="font-semibold text-lg">
                                        {{ row.event_dates }}
                                    </div>
                                    {{ row.events_count }} Events
                                </div>
                                <div class="md:hidden pr-4 w-1/12">
                                    <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"
                                              stroke-width="2"></path>
                                    </svg>
                                </div>
                                <div class="
              hidden
              md:block
                px-0
                pr-2
                sm:px-4
                py-3
                w-3/12
                md:w-2/12
                text-center
                md:pr-5
              ">
                                    <button class="
                                              px-2
                                              py-1
                                              md:px-4 md:py-2
                                              bg-blue-500
                                              text-white text-base
                                              sm:text-lg
                                              font-semibold
                                              rounded-md
                                              shadow-sm
                                              hover:bg-blue-600
                                              focus:outline-none focus:ring-2 focus:ring-blue-300
                                              leading-5
                                            ">
                                        Buy Tickets
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <PaginationClassic :resource="data" class="mt-4"/>
                </div>

                <div :class="{ hidden: activeTab !== 'INFO' }"
                     class="bg-white overflow-hidden shadow-sm sm:rounded-lg p-4">
                    <div class="text-lg md:text-xl font-semibold pb-3">{{ $page.props.currentCompany.name }}</div>
                    <Prose :content="$page.props.currentCompany.description"/>
                </div>
            </div>
        </div>

        <!-- Filter date or city modal -->
        <div v-if="filtersOpen" aria-labelledby="modal-title" aria-modal="true"
             class="fixed z-10 inset-0 overflow-y-auto"
             role="dialog">
            <div class="flex items-center justify-center min-h-screen pt-3 pb-24 px-4 text-center">
                <div aria-hidden="true" class="fixed inset-0 bg-gray-500/75 transition-opacity"
                     @click="filtersOpen = false">
                </div>
                <div
                    aria-labelledby="modal-headline"
                    aria-modal="true"
                    class="inline-block bg-white rounded-lg text-left overflow-visible shadow-xl transform transition-all max-w-lg w-full"
                    role="dialog">
                    <div class="p-4">
                        <!-- <div class="text-center sm:text-left font-semibold pb-2">Filters</div> -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <div class="text-sm font-semibold pb-2">City</div>
                                <SelectInput :options="city_filter.options" :searchable="false"
                                             :value="city_filter.selected"
                                             placeholder="Filter by city" @update="updateFilter($event, 'city')"/>
                            </div>
                            <div>
                                <div class="text-sm font-semibold pb-2">Date</div>
                                <SelectInput :options="month_filter.options" :searchable="false"
                                             :value="month_filter.selected"
                                             placeholder="Filter by date" @update="updateFilter($event, 'month')"/>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 rounded-b-lg px-4 py-4 flex justify-end gap-3">
                        <button
                            class="w-full inline-flex justify-center rounded-md border border shadow-sm px-4 py-2 bg-secondary font-medium text-dark hover:bg-grey-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-300 sm:w-auto text-sm"
                            type="button"
                            @click="clearFilters()">
                            Clear Filters
                        </button>
                        <button
                            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-300 sm:w-auto text-sm"
                            type="button"
                            @click="filtersOpen = false">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </BreezeShopLayout>
</template>

<script>
import { router } from "@inertiajs/vue3";
import BreezeShopLayout from "@/layouts/Shop.vue";
import {Head} from "@inertiajs/vue3";
// import { PlusSmIcon } from "@heroicons/vue/24/solid";
import TableHead from "@/components/Crud/TableHead.vue";
import TableCell from "@/components/Crud/TableCell.vue";
import Pagination from "@/components/ToSort/Pagination.vue";
import PaginationClassic from "@/components/ToSort/PaginationClassic.vue";
import SelectInput from "@/components/Shop/SelectInput.vue";
import Tabs from "@/components/Shop/Tabs.vue";
import Prose from "@/components/Shared/Prose.vue";

export default {
    data() {
        return {
            page_name: this.$page.props.currentCompany.name,
            activeTab: "EVENTS",
            filtersOpen: false,
        };
    },
    computed: {
        activeFilterCount() {
            let count = 0;
            if (this.city_filter.selected) {
                count++;
            }
            if (this.month_filter.selected) {
                count++;
            }
            return count;
        },
    },
    methods: {
        updateFilter: function (value, filter) {
            if (value) {
                let params = route().params;
                params[filter] = value;
                delete params["page"];
                router.get(route(route().current()), params);
            } else {
                this.clearFilter(filter);
            }
        },
        clearFilter: function (filter) {
            let params = route().params;
            delete params[filter];
            delete params["page"];
            router.get(route(route().current()), params);
        },
        clearFilters: function () {
            let params = route().params;
            delete params["city"];
            delete params["month"];
            delete params["page"];
            router.get(route(route().current()), params);
        },
    },
    components: {
        BreezeShopLayout,
        Head,
        TableHead,
        TableCell,
        Pagination,
        SelectInput,
        PaginationClassic,
        Tabs,
        Prose,
    },
    props: ["flash", "data", "month_filter", "city_filter"],
};
</script>
